import { useCallback } from "react";
import type { Release } from "@packages/commons";
import { useDialog } from "@imminently/decisively-ui/Dialog";
import { WORKSPACE_LAYER } from "@/ui/dialogs/layers";
import { BrowseReleasesModal } from "../components/BrowseReleasesModal";
import ReleaseModal from "../components/ReleaseModal";
import { DeleteReleaseModal } from "../components/DeleteReleaseModal";
import { ImportReleaseModal } from "../components/ImportReleaseModal";

export const useBrowseReleasesModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(
    (projectId: string) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "cover" },
        component: (props) => <BrowseReleasesModal {...props} projectId={projectId} />,
      });
    },
    [ pushDialog ],
  );
};

export const useReleaseModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(
    (baseRelease?: Release, mode: "edit" | "clone" | "promote" = "clone") => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: (props) => <ReleaseModal {...props} baseRelease={baseRelease} mode={mode} />,
      });
    },
    [ pushDialog ],
  );
};

export const useDeleteReleaseModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(
    (release: { id: string; releaseNo?: number }) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: (props) => <DeleteReleaseModal {...props} release={release} />,
      });
    },
    [ pushDialog ],
  );
};

export const useImportReleaseModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(
    (projectId: string) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: (props) => <ImportReleaseModal {...props} projectId={projectId} />,
      });
    },
    [ pushDialog ],
  );
};
